import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";

function SandeseAateHai() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Sandese Aate Hai</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>A soulful piano cover of the patriotic classic from the movie Border.</p>
          <div style={{ width: 340, height: 191, marginBottom: 24, borderRadius: 24, overflow: "hidden", boxShadow: "0 4px 32px rgba(0,0,0,0.10)" }}>
            <iframe
              width="340"
              height="191"
              src="https://www.youtube.com/embed/YY7KMoXvtXY"
              title="Sandese Aate Hai Piano Cover"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: 24, width: "100%", height: "100%" }}
            ></iframe>
          </div>
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            "Sandese Aate Hai" is a deeply emotional patriotic song that honors the sacrifice of soldiers. The piano rendition captures the song's poignant melody and heartfelt sentiment. Watch the video above!
          </div>
        </section>
        {/* About this song section */}
        <section style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "40px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>About this song</h2>
            <p style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7 }}>
              "Sandese Aate Hai" is a patriotic song from the 1997 Bollywood war film Border. The song beautifully captures the emotions of soldiers and their families, making it one of the most beloved patriotic songs in Indian cinema. Its touching melody makes it perfect for piano interpretation.
            </p>
            <ul style={{ fontSize: "1.05rem", color: "#555", marginTop: 18, marginLeft: 18 }}>
              <li>Released: 1997</li>
              <li>Movie: Border</li>
              <li>Genre: Patriotic, Bollywood</li>
              <li>Music Director: Anu Malik</li>
            </ul>
          </div>
        </section>
        {/* Fun facts / fill space visually */}
        <section style={{
          marginTop: 64,
          background: "rgba(255,255,255,0.7)",
          borderRadius: 32,
          maxWidth: 1100,
          marginLeft: "auto",
          marginRight: "auto",
          padding: "36px 32px 32px 32px",
          boxShadow: "0 2px 24px rgba(30,60,120,0.07)",
          display: "flex",
          flexDirection: "row",
          gap: 48,
          alignItems: "center",
          justifyContent: "center"
        }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 12, color: "#1a3a5d" }}>Why this song?</h3>
            <p style={{ fontSize: "1rem", color: "#444", lineHeight: 1.6 }}>
              This song holds a special place in Indian hearts for its tribute to the armed forces. The piano version allows the beautiful melody to shine through, emphasizing the emotional depth and patriotic spirit that makes this song timeless.
            </p>
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 12, color: "#1a3a5d" }}>Musical highlights</h3>
            <p style={{ fontSize: "1rem", color: "#444", lineHeight: 1.6 }}>
              The song features a hauntingly beautiful melody that translates wonderfully to piano. Its moderate tempo and emotional progression make it both touching to play and deeply moving to listen to.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}

export default SandeseAateHai;
